import { money } from "../../utilities/currency";

/** Nederlands (Dutch) */
const nl = {
  home: {
    offer: "✨ Speciale aanbieding – Betaal 99 kr, ontvang 198 kr beltegoed! ✨",
    signIn: "Inloggen",
    join: "Word lid",
    allAdvisors: "Alle adviseurs",
    festivalTitle: "Festivalcampagnes",
    referTitle: "Ontvang je eerste consult gratis!",
    referBody:
      "Boek een gratis gesprek van 15 minuten. Perfect om de juiste adviseur te vinden – veilig, digitaal en vrijblijvend.",
    blogTitle: "Van de Mystic-blog",
    viewAll: "Bekijk alles",
    subscribeLine: "Ontvang nieuwe gidsen en aanbiedingen per e-mail.",
    read: "Lezen",
    invite: "Boek een gratis consult",
    sponsored: "Gesponsord",
    ad: (n) => `Advertentie ${n}`,
    adBlurb: "Adverteer hier producten, apps of evenementen.",
    learnMore: "Meer informatie",
    connectNow: "Nu verbinden",
    from: "vanaf",
    minutes: "min",
    verified: "Geverifieerd",
    categories: [
      "Liefdesreading",
      "Helderziende reading",
      "Tarot-reading",
      "Astrologie & Horoscoop",
      "Engelboodschappen",
      "Orakelbegeleiding",
      "Droomduiding",
      "Spiritueel medium",
    ],
    hero: {
      name: "De Adviseurs",
      tag: "Liefdesexpert",
      blurb:
        "Mijn belofte: Ik ben er voor je. Wanneer het moeilijk is om te weten wie je kunt vertrouwen, is echte aanwezigheid alles.",
      getReading: "Consult boeken",
    },
    footer: {
      getApp: "Download de app voor helderheid waar je ook bent.",
      explore: "Ontdek",
      special: "Specialiteiten",
      more: "Meer",
      advisors: "Adviseurs",
      blog: "Onze blog",
      applyCode: "Actiecode gebruiken",
      support: "Klantenservice",
      about: "Over ons",
      apply: "Adviseur? Meld je hier aan",
      privacy: "Privacy",
      terms: "Voorwaarden",
    },
    wallet: {
      title: "Belminuten kopen",
      intro:
        "Minuten worden opgeslagen in je Mystic-wallet en kunnen bij elke adviseur worden gebruikt (chat / gesprek / video).",
      numLabel: "Het telefoonnummer waarvandaan je belt",
      amount: "Kies bedrag",
      buy: (amt) => `Koop ${money(amt)} tegoed`,
      learn: "Lees meer over betaalmethoden",
      err: "Voer een geldig telefoonnummer in",
      otp: (n) => `Code verzonden naar ${n}. Voer hem in om te bevestigen.`,
      enterOtp: "Voer code in",
      verify: "Bevestigen & tegoed toevoegen",
      cancel: "Annuleren",
      success: (amt) => `${money(amt)} toegevoegd aan je wallet!`,
      pm1: "Vipps MobilePay",
      pm2: "Kaart (vereist registratie op je mobiele nummer)",
      nolgin: "Geen login nodig voor Vipps MobilePay – bel direct.",
    },
  },

  header: {
    hello: "Hoi",
    logout: "Uitloggen",
    login: "Inloggen",
  },

  footer: {
    categories: [
      "Dummy 1",
      "Dummy 2",
      "Dummy 3",
      "Dummy 4",
      "Dummy 5",
      "Dummy 6",
      "Dummy 7",
      "Dummy 8",
    ],
    paymentMethods: "Betaalmethoden",
    footer: {
      getApp: "Download de app voor helderheid waar je ook bent.",
      explore: "Ontdek",
      special: "Specialiteiten",
      more: "Meer",
      advisors: "Adviseurs",
      blog: "Onze blog",
      applyCode: "Actiecode gebruiken",
      support: "Klantenservice",
      about: "Over ons",
      apply: "Adviseur? Meld je hier aan",
      privacy: "Privacy",
      terms: "Voorwaarden",
    },
  },
};

export default nl;
